// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3m5zi","choiceBoxes":"toolbarselects_choiceBoxes__1DRId","simpleField":"toolbarselects_simpleField__FktnT"};